<template>
    <div>
        <template v-if="dataRecords.length > 0">
            <!-- <v-alert
                border="right"
                outlined
                type="error"
                v-if="hasErrors"
            >
                Existen {{ getNumberOfErrors }} items con errores en la Biblia
            </v-alert>
            -->

            <v-data-table
                :headers="dataTableHeaders"
                :items="dataRecords"
                :items-per-page="pagination.max"
                item-key="_id"
                :single-expand="dataTable.singleExpand"
                :expanded.sync="dataTable.expanded"
                :options.sync="dataTable.options"
                :loading="flags.fetch_data_records"
                show-expand
                hide-default-footer
                class="table"
            >
                <template #header.name="header">
                    {{ header.header.text }}
                </template>

                <template #header.program="header">
                        {{ header.header.text }}
                </template>

<!--                <template #header.actions>
                    <div class="d-flex justify-end">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    class="btn-icon--primary btn-icon"
                                    align-self-end
                                    @click="flags.show_data_gathering_configuration_dialog = !flags.show_data_gathering_configuration_dialog"
                                >
                                    <v-icon>mdi-cog</v-icon>
                                </v-btn
                                >
                            </template>
                            <span>Bible Configuration</span>
                        </v-tooltip>
                    </div>
                </template>-->

                <!-- custom display item -->
                <template v-for="column in customRowItems" :slot="'item.' + column.id" slot-scope="item">
                    <data-record-list-item-value
                        :key="column.id"
                        :column="column"
                        :item="item.item"
                        no-label
                    />
                </template>

                <template v-for="column in columns" :slot="'header.' + column.id" slot-scope="item">
                    <data-record-header-item-value
                        :key="column.id"
                        :column="column"
                        :item="item.item"
                        no-label
                    />
                </template>

                <template v-if="checkPermission('DATA_SOURCES_DATA_RECORDS_EDIT') || checkPermission('DATA_SOURCES_DATA_RECORDS_DELETE')" #item.actions="{ item }">
                    <div class="d-flex justify-end">
                        <v-tooltip top v-if="item.error && item.error.length > 0">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    class="btn-icon--warning btn-icon"
                                >
                                    <v-icon>mdi-exclamation</v-icon>
                                </v-btn
                                >
                            </template>
                            <span>Some errors where detected in this row</span>
                        </v-tooltip>

                        <v-btn
                            v-if="checkPermission('DATA_SOURCES_DATA_RECORDS_EDIT')"
                            :disabled="isDisabled(status, dataGathering)"
                            class="btn-icon--primary btn-icon ml-3"
                            @click="onEditDataRecord(item)"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                            v-if="checkPermission('DATA_SOURCES_DATA_RECORDS_DELETE')"
                            :disabled="isDisabled(status, dataGathering)"
                            class="btn-icon--delete btn-icon ml-3"
                            @click="onDeleteDataRecord(item)"
                        >
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </div>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="no-padding">
                        <data-records-extended-row
                            :headers="columns"
                            :item="item"
                        />
                    </td>
                </template>
            </v-data-table>

            <div class="text-center pt-2">
                <v-pagination
                    class="pagination"
                    :disabled="flags.fetch_data_records"
                    v-model="pagination.page"
                    :length="pagination.pages"
                    :total-visible="pagination.visible_pages"
                    @input="onPaginationChange"
                />
            </div>
        </template>

        <no-results v-else :text="$t('data_gatherings.no_results')" />

        <!-- data-record edit dialog -->
        <v-dialog
            v-model="flags.show_edit_data_record_form_dialog"
            persistent
            max-width="658px"
            scrollable
            content-class="bible-form-dialog"
        >
            <data-record-edit-form
                @save="onSaveEditDataRecord"
                @cancel="onCancelEditDataRecord"
            />
        </v-dialog>

        <!-- data-gathering configuration dialog -->
        <v-dialog
            v-model="flags.show_data_gathering_configuration_dialog"
            persistent
        >
            <!--<data-gathering-configuration
                @cancel="toggleBibleConfiguration"
            />-->
        </v-dialog>

        <!-- data-record delete confirmation -->
        <v-dialog
            v-model="flags.show_delete_data_record_confirmation_dialog"
            width="724px"
            heigth="515px"
        >
            <!-- Custom :title value to delete data record dialog -->
            <action-confirmation-card
                :title="dataRecordDelete"
                :loading="flags.loading"
                @confirm="onDeleteDataRecordDialogConfirm"
                @cancel="flags.show_delete_data_record_confirmation_dialog = false"
            />
        </v-dialog>
    </div>
</template>

<script>
import ActionConfirmationCard from "@/Shared/ActionConfirmationCard";
//import BibleConfiguration from "../Index/BibleConfiguration.vue";
import NoResults from "../../Common/NoResults.vue";
import {DataRecordsStore} from "@/Store/DataGatherings/DataRecordsStore";
import DataRecordListItemValue from "@/Shared/DathaGatherings/Common/Records/DataRecordListItemValue";
import DataRecordHeaderItemValue from "@/Shared/DathaGatherings/Common/Records/DataRecordHeaderItemValue";
import {mapState, mapActions} from "pinia";
import {supportedTypes} from "@/Shared/DathaGatherings/Common/DynamicInput";
import DataRecordsExtendedRow from "@/Shared/DathaGatherings/Common/Records/DataRecordsExtendedRow";
import DataRecordEditForm from "@/Shared/DathaGatherings/Common/Records/DataRecordEditForm.vue";
import {bibleResumeAbbr} from "@/Repositories/DataGathering/DataGatheringRepository";
import {PermissionsStore} from "@/Store/PermissionsStore";

export default {
    components: {
        DataRecordsExtendedRow,
        DataRecordHeaderItemValue,
        DataRecordListItemValue,
        ActionConfirmationCard,
        //BibleConfiguration,
        //BibleRecordEditForm,
        NoResults,
        DataRecordEditForm
    },

    data() {
        return {
            flags: {
                show_edit_data_record_form_dialog: false,
                show_data_gathering_configuration_dialog: false,
                show_delete_data_record_confirmation_dialog: false,
                loading: false,
                fetch_data_records: false,
            },

            dataTable: {
                singleExpand: false,
                expanded: [],
                options: {},
            },

            dataRecordDelete: this.$t('data_records.delete_title'),
        };
    },

    methods: {
        // Disabled closed status and data gathering type abbr --> resume RECU
        isDisabled(status, dataGathering) {
            return status === 'closed' || bibleResumeAbbr.inArray(dataGathering.type.abbr);
        },

        onEditDataRecord(dataRecord, index){
            this.setCurrentDataRecord(dataRecord, index);

            this.flags.show_edit_data_record_form_dialog = true;
        },

        onSaveEditDataRecord() {
            this.$emit('generated');
            this.hideEditDataForm();
        },

        onCancelEditDataRecord() {
            this.hideEditDataForm();
        },

        hideEditDataForm() {
            this.flags.show_edit_data_record_form_dialog = false;

            this.clearCurrentDataRecord();
        },

        onDeleteDataRecord(dataRecord, index) {
            this.flags.show_delete_data_record_confirmation_dialog = true;

            this.setCurrentDataRecord(dataRecord, index);
        },

        onDeleteDataRecordDialogConfirm() {
            this.flags.loading = true;

            this.delete()
                .catch()
                .then(() => {
                    this.flags.loading = false;
                    this.flags.show_delete_data_record_confirmation_dialog = false;
                    this.onPaginationUpdate()
                });
        },

        onPaginationChange(page){
            if(typeof page !== 'undefined'){
                this.fetch();
            }
        },

        onPaginationUpdate(){
            if (this.dataRecords.length === 0) {
                this.pagination.page = this.pagination.pages;
                this.fetch();
            }
        },

        updateEditData(data) {
            this.editData = data;
        },

        confirmationModalToggle() {
            this.confirmationModalShow = !this.confirmationModalShow;
        },

        toggleBibleConfiguration() {
            this.configModal = !this.configModal;
        },

        fetch() {
            this.flags.fetch_data_records = true;

            this.fetchDataRecords()
                .catch()
                .then((res) => {
                    this.flags.fetch_data_records = false
                });
        },

        ...mapActions(DataRecordsStore, [
            'fetchDataRecords',
            'applySorting',
            'setCurrentDataRecord',
            'clearCurrentDataRecord',
            'delete',
        ]),

        ...mapActions(PermissionsStore, ['checkPermission']),
    },

    computed: {
        ...mapState(DataRecordsStore, [
            'filters',
            'columns',
            'visibleColumns',
            'dataTableHeaders',
            'dataRecords',
            'pagination',
            'status',
            'dataGathering',
        ]),

        customRowItems() {
            return this.visibleColumns.filter(column => supportedTypes.inArray(column.type));
        },

        disableExpand() {
            return window.location.pathname.includes('surveys');
        },
    },

    watch: {
        'dataTable.options': {
            handler(newOptions, oldOptions) {
                if(!(_.isEmpty(newOptions) || _.isEmpty(oldOptions))){
                    this.applySorting(this.dataTable);

                    this.fetch();
                }
            },

            deep: true,
        },

        'pagination.total': {
            handler(newValue) {
                if(newValue === 0 && isEmpty(this.filters)) {
                    this.$emit('emptyRecords');
                }
            }
        },
    },

    mounted() {

    },
};
</script>

<style scoped>
    .no-padding{
        padding: 0;
    }

    th, td {
        text-align: left !important;
    }

    .table {
        th:nth-last-child(2),
        td:nth-last-child(2) {
            position: sticky !important;
            right: 0 !important;
            z-index: 1 !important;
            background-color: inherit !important;
        }
    }
</style>
